module.exports = __webpack_public_path__ + "static/media/takeback_profit.5fed1cc8.svg";